// extracted by mini-css-extract-plugin
export var label = "_dj-1";
export var reminder = "_dj-0";